import React from "react";
import Tooltip, {tooltipClasses, TooltipProps} from "@mui/material/Tooltip";
import styled from "@mui/material/styles/styled";
import {CPSConstants} from "commonUtils/enumerations";

export const LightTooltip = styled(({className, ...props}: TooltipProps) => (
  <Tooltip {...props} classes={{popper: className}} />
))(({theme}) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    backgroundColor: theme.palette.common.white,
    color: "rgba(0, 0, 0, 0.87)",
    border: "5px solid lightgray",
    boxShadow: theme.shadows[1],
    fontSize: 11,
  },
}));
